export const unwrapFromBElement = (boldElement: Element) => {
  boldElement.replaceWith(...boldElement.childNodes)
}
